import React from 'react';
import Pullable from 'react-pullable';

const TdtPullable = ({ onRefresh, ...rest }) => {
    return <Pullable {...rest} onRefresh={onRefresh} />;
};

export default TdtPullable;
